import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../enviroments/enviroment';
import { catchError, EMPTY, map, Observable, tap } from 'rxjs';
import { SpinnerService } from './spinner.service';

@Injectable({ providedIn: 'root' })
export class CaptchaValidationService {
  constructor(private http: HttpClient, private spinner: SpinnerService) {}

  public validateCaptcha(token: string): Observable<boolean> {
    this.spinner.show('Validando captcha...');
    return this.http.put<{ success: true }>(`${environment.apiUrl}/validate-captcha`, { token }).pipe(
      catchError(() => {
        return EMPTY;
      }),
      tap(() => this.spinner.hide()),
      map(({ success }) => success),
    );
  }
}
